export default {
  vi: {
    menu: 'Menu',
    home: 'Trang chủ',
    productCategory: 'Danh Mục Sản Phẩm',
    blogCategory: 'Danh Mục Blog',
    blog: 'Blog',
    shop: 'Shop',
  },
  'en-us': {
    productCategory: 'Product Category',
    blogCategory: 'Blog Category',
    menu: 'Menu',
    home: 'Home',
    blog: 'Blog',
    shop: 'Shop',
  },
}
